/**
 * Раскладка мозаики категорий.
 *
 * Сетка — 3 колонки. Основной паттерн повторяется группами по шесть:
 *
 *   ряд 1: ██████ ██      горизонтальный 221×106 + квадрат
 *   ряд 2: ██ ██████      вертикальный 106×220 (на два ряда) + горизонтальный
 *   ряд 3: ██ ██          два квадрата (правее вертикального)
 *
 * Категорий в базе может быть любое число: раньше паттерн считался как
 * `index % 6` и на седьмой категории сетка ехала — неполная группа
 * оставляла дырки. Поэтому остаток раскладывается отдельно: у каждого
 * из пяти вариантов хвоста ряды закрываются целиком.
 */

const SPAN_1 = { gridColumn: 'span 1', aspectRatio: '1/1' };
const SPAN_2 = { gridColumn: 'span 2', aspectRatio: '221/106' };
const SPAN_3 = { gridColumn: 'span 3', aspectRatio: '336/106' };
const SPAN_TALL = { gridColumn: 'span 1', gridRow: 'span 2', aspectRatio: '106/220' };

// Полная группа из шести
const GROUP = [SPAN_2, SPAN_1, SPAN_TALL, SPAN_2, SPAN_1, SPAN_1];

// Хвост по остатку от деления на шесть. Вертикальной плитки здесь нет:
// она занимает два ряда и в неполной группе оставила бы пустую клетку
const TAILS = {
  1: [SPAN_3],
  2: [SPAN_2, SPAN_1],
  3: [SPAN_1, SPAN_1, SPAN_1],
  4: [SPAN_2, SPAN_1, SPAN_1, SPAN_2],
  5: [SPAN_1, SPAN_1, SPAN_1, SPAN_2, SPAN_1],
};

/**
 * Стили плиток для N категорий, по одному на каждую.
 * @param {number} count
 * @returns {Array<object>}
 */
export const buildMosaic = (count) => {
  const styles = [];
  const fullGroups = Math.floor(count / GROUP.length);

  for (let i = 0; i < fullGroups; i++) {
    styles.push(...GROUP);
  }

  const rest = count % GROUP.length;
  if (rest > 0) {
    styles.push(...TAILS[rest]);
  }

  return styles;
};

// Скелетон повторяет ту же раскладку — иначе при загрузке ровные плитки
// сменяются мозаикой и экран дёргается
export const MOSAIC_SKELETON = buildMosaic(6);
